module.exports = __webpack_public_path__ + "static/dashboard_segmenetation-e7d75f5efb622cdfebdb7368dfaf522f.png";